import { Check, Circle, LoaderCircle, TriangleAlert, X } from 'lucide-react';
import { OverlayReadinessStatus } from 'modules/overlay-v2/domain/interfaces/readiness';
import React from 'react';

import { StatusBadge } from './styles';

interface StatusIconProps {
  status: OverlayReadinessStatus;
}

/** Подписи для скринридера и для тестов: по иконке статус шага иначе не прочитать. */
const STATUS_LABELS: Record<OverlayReadinessStatus, string> = {
  pending: 'ожидает',
  running: 'выполняется',
  done: 'готово',
  warning: 'с оговоркой',
  failed: 'не получилось',
};

const ICONS: Record<OverlayReadinessStatus, typeof Check> = {
  pending: Circle,
  running: LoaderCircle,
  done: Check,
  warning: TriangleAlert,
  failed: X,
};

function StatusIcon({ status }: StatusIconProps) {
  const Icon = ICONS[status];

  return (
    <StatusBadge className={status} stepStatus={status} role={'img'} aria-label={STATUS_LABELS[status]}>
      <Icon strokeWidth={status === 'done' ? 3 : 2} />
    </StatusBadge>
  );
}

export default React.memo(StatusIcon);
